import { useEffect, useRef, useState } from "react";
import LeadDialog from "./LeadDialog";
import { Autocomplete, Box, TextField } from "@mui/material";
import { handleValidateCodevalue, MAX_TOTAL_SIZE } from "../Utility/constant";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { createRequestData, isValidPhoneNumber } from "../Utility/apiHelper";

import { requestHideDialogLoader, requestShowDialogLoader } from "../Store/Global/action";
import { StyledLeadContainer, StyledSubHeader } from "./Styled";
import { emptyTemplateList, requestGetTemplateList } from "../Store/Template/action";
import TextFiledWithLabel from "./TextFieldWithLabel";
import TemplateBody from "./TemplateBody";
import Attachments from "./Attachments";
import { getTotalAttachmentSize } from "../Utility/calculations";
import { removeExcessiveTags } from "../Utility/textHelper";
import PhoneNumberField from "./PhoneNumberField";
import InfoIcon from "./Widgets/InfoIcon";

const deduplicateEmails = (emailString) => {
  if (!emailString || typeof emailString !== 'string') return '';
  
  const emails = emailString
    .split(',')
    .map(email => email.trim())
    .filter(email => email);
  
  const uniqueEmails = new Map();
  emails.forEach(email => {
    const lowerEmail = email.toLowerCase();
    if (!uniqueEmails.has(lowerEmail)) {
      uniqueEmails.set(lowerEmail, email);
    }
  });
  
  return Array.from(uniqueEmails.values()).join(', ');
};


const removeCCDuplicates = (toEmailString, ccEmailString) => {
  if (!ccEmailString || typeof ccEmailString !== 'string') return '';
  if (!toEmailString || typeof toEmailString !== 'string') return deduplicateEmails(ccEmailString);
  
  const toEmails = toEmailString
    .split(',')
    .map(email => email.trim().toLowerCase())
    .filter(email => email);
  
  const toEmailsSet = new Set(toEmails);
  
  const ccEmails = ccEmailString
    .split(',')
    .map(email => email.trim())
    .filter(email => email && !toEmailsSet.has(email.toLowerCase()));
  
  const uniqueCCEmails = new Map();
  ccEmails.forEach(email => {
    const lowerEmail = email.toLowerCase();
    if (!uniqueCCEmails.has(lowerEmail)) {
      uniqueCCEmails.set(lowerEmail, email);
    }
  });
  
  return Array.from(uniqueCCEmails.values()).join(', ');
};

const SendNotification = ({
  open,
  title,
  selectedDetails,
  setIsOpenNotificationDialog,
  type,
  subject,
  toEmailId,
  ccEmailId,
  handleSuccess,
  entityId,
  entityType,
  isWhatsapp = false,
  disableSubject = true,
  channel,
  whatsappNumber,
  handleCloseDialog,
  onSave,
  defaultValues,
  isWorkflow = false,
  autoFillSubjectFromTemplate = false,
  isViewMode=false,
  phoneCountryCode="+91"
}) => {
  const internationalise = useSelector(
    state => state?.internationalise?.currentHashMapData
  );
  const { enqueueSnackbar } = useSnackbar();
  const deduplicatedToEmail = deduplicateEmails(toEmailId);
  const deduplicatedCCEmail = removeCCDuplicates(deduplicatedToEmail, ccEmailId);
  const isLead = entityType?.toLowerCase() === "lead";

  const [notificationDetails, setNotificationDetails] = useState({
    subject,
    phoneCountryCode : phoneCountryCode,
    toEmailId: deduplicatedToEmail,
    ccEmailId: deduplicatedCCEmail,
    phone: whatsappNumber,
    selectedTemplate: null
  })
  const [templateBody,setTemplateBody]= useState("")
  const [requiredError,setRequiredError] = useState({
    toEmailId : false,
    subject : false

  })
    useEffect(() => {
  
      if (!open) return;
      if(isWorkflow){
      if (!defaultValues || Object.keys(defaultValues).length === 0) {  
      setNotificationDetails({ subject: "", selectedTemplate: null });
      setTemplateBody("");
      setNewAttachments([]); return;
      }
    const template = templateData?.find(
      t => t.id === defaultValues.templateId
    );
  
      setNotificationDetails({
        subject: defaultValues.subject || "",
        selectedTemplate: template
        ? {
            ...template,
            attachments: defaultValues.templateAttachments || []
          }
        : null
      });
  
      setTemplateBody(defaultValues.body || "");
      setNewAttachments([]);
    }
    }, [open, defaultValues, isWorkflow]);
    
  const dispatch = useDispatch()
    const handleSelectTemplate = async (e,val)=>{
        setNotificationDetails(prev=>({
          ...prev,
          selectedTemplate : val,
          ...(autoFillSubjectFromTemplate && val?.subject ? { subject: val.subject } : {} )
        }))
        setTemplateBody(val?.templateBody)

    }
  const [newAttachments,setNewAttachments] = useState([])

const handleSelectFile = (files) => {
  if (!files?.length) return;

  const incomingSize = files.reduce(
    (sum, file) => sum + file.size,
    0
  );



  const totalSize = getTotalAttachmentSize(notificationDetails?.selectedTemplate,newAttachments) + incomingSize;

  if (totalSize > MAX_TOTAL_SIZE) {
    enqueueSnackbar(handleValidateCodevalue(internationalise,"ATTACHMENT_SIZE_EXCEEDED"), { variant: "error" });
    return;
  }

  setNewAttachments(prev => [...prev, ...files]);
};


    const [dataGridData , setDatagridData] = useState([])

    const templateData  = useSelector(state => state?.template?.templateList)
    useEffect(()=>{  
    const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/get-all-notification?systemTemplateFlag=false&status=TEMPLATE_STATUS_ACTIVE&channel=${channel}`;
      dispatch(requestGetTemplateList(url))
      return ()=>{
        dispatch(emptyTemplateList())
      }
    },[])

    useEffect(()=>{
      setDatagridData(templateData || []);
    },[templateData])

const handleSend = async () => {
if(!notificationDetails?.subject || !notificationDetails?.toEmailId){
  enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS"),{variant : "error"})
setRequiredError({
  toEmailId : true,
  subject : true
})
return;
}

    try {
      dispatch(requestShowDialogLoader());

      const formData = new FormData();

      const processEmailList = (emailString) => {
        return emailString
          ? emailString.split(",").map((e) => e.trim()).filter((e) => e)
          : [];
      };

      const requestBody = {
        to: processEmailList(notificationDetails?.toEmailId),
        cc: processEmailList(notificationDetails?.ccEmailId),
        subject: notificationDetails?.subject || "",
        body: removeExcessiveTags(templateBody) || "",
        ids: selectedDetails || [],
        type: type,
        templateId: notificationDetails?.selectedTemplate?.id,
        documentIds: notificationDetails?.selectedTemplate?.attachments?.map(
          (att) => att.document_id
        ) || [],
        taskId: (entityType === "Task" || entityType === "TASK") ? entityId : null,
        leadId: (entityType === "Lead" || entityType === "LEAD") ? entityId : null
      };

      formData.append(
        "data",
        new Blob([JSON.stringify(requestBody)], { type: "application/json" })
      );

      newAttachments.forEach((file) => {
        formData.append("file", file);
      });

      const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/send-transactional-mail`;

      const response = await createRequestData(formData, url, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response?.status === 200) {
        enqueueSnackbar(
          handleValidateCodevalue(internationalise, response?.data),
          { variant: "success" }
        );
        handleSuccess?.();
        handleClose();
      } else {
        enqueueSnackbar(
          handleValidateCodevalue(
            internationalise,
            response?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
          ),
          { variant: "error" }
        );
      }
    } catch (error) {
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"),
        { variant: "error" }
      );
    } finally {
      dispatch(requestHideDialogLoader());
    }
  };
const sendWhatsapp = async () => {
  if (!isValidPhoneNumber(notificationDetails?.phone,notificationDetails?.phoneCountryCode) || !notificationDetails?.selectedTemplate) {
    enqueueSnackbar(
      handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"),
      { variant: "error" }
    );

    setRequiredError({
      phone: true,
      selectedTemplate:true,
    });

    return;
  }

  try {
    dispatch(requestShowDialogLoader());
    const formattedParams = Object.fromEntries(
      paramsList.filter(p => p.value).map(p => [p.key, p.value])
    );
    const payload = {
      phone: notificationDetails.phone,
      templateName: notificationDetails.selectedTemplate.name,
      language: notificationDetails.selectedTemplate.language,
      parameters: formattedParams,
      body: templateBody || "",
      taskId: entityType?.toLowerCase() === "task" ? entityId : null,
      leadId: entityType?.toLowerCase() === "lead" ? entityId : null,
    };

    const url = `${process.env.REACT_APP_BASE_URL}whatsapp/send`;

    const response = await createRequestData(payload, url);

    if (response?.status === 200) {
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, response?.data?.message),
        { variant: "success" }
      );

      handleSuccess?.();
      handleClose();
    } else {
      throw response; 
    }
  } catch (error) {
    enqueueSnackbar(
      handleValidateCodevalue(
        internationalise,
        error?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
      ),
      { variant: "error" }
    );
  } finally {
    dispatch(requestHideDialogLoader());
  }
};
  const handleSave = async () => {
  if(!notificationDetails?.subject){
    enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS"),{variant : "error"})
  setRequiredError({
    subject : true
  })
  return;
  }
    let uploadedAttachments = [];
    if (newAttachments && newAttachments.length > 0) {
      dispatch(requestShowDialogLoader());
      const uploadUrl = `${process.env.REACT_APP_BASE_URL}documents`;
      
      try {
        for (const file of newAttachments) {
          const formData = new FormData();
          formData.append("file", file);
          
          const response = await createRequestData(formData, uploadUrl, true); // true for isFile
          
          if (response?.status === 201 && response?.data?.id) {
            // Document upload returns a JSON object with 'id', 'name', 'path', 'clientId'
            uploadedAttachments.push({
              document_id: response.data.id,
              file_name: file.name,
              file_size: file.size
            });
          } else {
             enqueueSnackbar(
               handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"),
               { variant: "error" }
             );
             dispatch(requestHideDialogLoader());
             return; // abort save if an upload fails
          }
        }
      } catch (error) {
        enqueueSnackbar(
          handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"),
          { variant: "error" }
        );
        dispatch(requestHideDialogLoader());
        return;
      }
      
      dispatch(requestHideDialogLoader());
    }

    const payload = {
      subject: notificationDetails?.subject,
      body: templateBody,
      templateId: notificationDetails?.selectedTemplate?.id,
      attachments: uploadedAttachments,
     templateAttachments: [
      ...(notificationDetails?.selectedTemplate?.attachments || []),
      ...uploadedAttachments
    ]
    };

    onSave?.(payload);

  };
const handleClose = () =>{
  setDatagridData([])
setIsOpenNotificationDialog({
    required : false,
    isWhatsapp:false,
    selectedTemplate : null,
    isOpen : false,
    list : [],
    selected : [],
})
}
const handleOnChange = (event)=>{
const  {name,value} = event?.target
setNotificationDetails(prev=>({
  ...prev,
  [name] : value
}))
}
const handleQuillChange = (value) => {
  setTemplateBody(value)
};
  const handleRemoveNewAttachment = (index) => {
    setNewAttachments(prev => prev.filter((_, i) => i !== index));
  }
const handleRemoveOldAttachment = (id) => {
  setNotificationDetails(prev => {
    const updatedAttachments =
      prev?.selectedTemplate?.attachments?.filter(
        item => item.document_id !== id
      ) || [];

    return {
      ...prev,
      selectedTemplate: {
        ...prev.selectedTemplate,
        attachments: updatedAttachments
      }
    };
  });
};

        const quillRef = useRef(null);

const handleAddParam = (value) => {
  const quill = quillRef.current?.getEditor();
  if (!quill || !value) return;

  const range = quill.getSelection(true);
  const index = range?.index ?? quill.getLength();

  if (value.includes("<")) {
    quill.clipboard.dangerouslyPasteHTML(index, value, "user");
  } else {
    quill.insertText(index, value, "user");
  }

  quill.setSelection(quill.getLength());
};


const [paramsList, setParamsList] = useState([]);




  return (
    <LeadDialog
      open={open}
      handleClose={handleCloseDialog || handleClose}
      title={title}
      size="lg"
      selectedowner
      btnlabel={isViewMode ? "" : isWorkflow ? handleValidateCodevalue(internationalise, "COMMON_SAVE") : handleValidateCodevalue(internationalise, "COMMON_SEND")}
      handleSave={isWorkflow ? handleSave : isWhatsapp ? sendWhatsapp : handleSend}
    >
        {isWhatsapp && (
    <StyledLeadContainer sx = {{ p: "0px 8px" }}>
      <PhoneNumberField
        required = {true}
        isDetailPage={true}
        isRequired={requiredError?.phone || false}
        name="phone"
        sx={{ minWidth: "48%" }}
        value={notificationDetails?.phone}
        countryCodeName="phoneCountryCode"
        countryCode={notificationDetails?.phoneCountryCode || "+91"}
        handleOnChange={handleOnChange}
      />
    </StyledLeadContainer>
  )} {(!isWhatsapp && !isWorkflow) && (
    <>
        <StyledLeadContainer sx = {{ p: "0px 8px" }} className="mb-20">
          <TextFiledWithLabel
            name="toEmailId"
            sx={{ minWidth: "48%" }}
            required
            error={notificationDetails?.toEmailId ? false : requiredError?.toEmailId}
            value={notificationDetails?.toEmailId}
            label={handleValidateCodevalue(internationalise, 'COMMON_TO_EMAIL')}
            handleOnChange={handleOnChange}
          />
          <TextFiledWithLabel
            name="ccEmailId"
            sx={{ minWidth: "48%" }}
            value={notificationDetails?.ccEmailId}
            label={handleValidateCodevalue(internationalise, 'COMMON_CC_EMAIL')}
            handleOnChange={handleOnChange}
          />
        </StyledLeadContainer>

      <StyledLeadContainer sx = {{ p: "0px 8px" }} className="mb-20">
        <TextFiledWithLabel
          name="subject"
          value={notificationDetails?.subject}
          required
          disabled={disableSubject || isViewMode}
          handleOnChange={handleOnChange}
          error={notificationDetails?.subject ? false : requiredError?.subject}
          style={{ width: "72%" }}
          label={handleValidateCodevalue(internationalise, 'CAMP_SUBJECT')}
        />
      </StyledLeadContainer>
    </>
  )}
       {notificationDetails && (
        <Box sx = {{ p: "0px 8px" }}>
          <StyledSubHeader sx = {{paddingTop : 0}}>
            {handleValidateCodevalue(internationalise,"SN_TEMPLATE_PREVIEW")}
          </StyledSubHeader>
          <StyledLeadContainer className="mb-20">
      <Autocomplete
        options={dataGridData}
        sx={{ width: "48%"}}
        disabled = {isViewMode}
        getOptionLabel={(option) => option?.name || ""}
        value={notificationDetails?.selectedTemplate}
        onChange={handleSelectTemplate}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
          required={isWhatsapp}
            error={ (isWhatsapp && !notificationDetails?.selectedTemplate) ? requiredError?.selectedTemplate : false}
            variant="standard"
            label={handleValidateCodevalue(
              internationalise,
              "CAMP_SELECT_TEMP"
            )}
            fullWidth
          />
        )}
      />
      {isWorkflow &&
        <TextFiledWithLabel
          sx = {{marginTop : 2}}
          name="subject"
          value={notificationDetails?.subject}
          required
          disabled={disableSubject || isViewMode}
          handleOnChange={handleOnChange}
          error={notificationDetails?.subject ? false : requiredError?.subject}
          style={{ width: "72%" }}
          label={handleValidateCodevalue(internationalise, 'CAMP_SUBJECT')}
          helperText={  
            <InfoIcon
              text = "WF_SUBJECT_WARNING"
            /> 

          }
        />
        }
      </StyledLeadContainer>
          <TemplateBody
          isWhatsapp={isWhatsapp}
          paramsList={paramsList}
          setParamsList={setParamsList}
          disabled = {isWhatsapp || isViewMode}
          handleQuillChange = {handleQuillChange}
          templateBodyValue = {templateBody}
          handleAddParam={handleAddParam}
          quillRef={quillRef}
          />
          {!isWhatsapp &&
          <Attachments
          isViewMode={isViewMode}
  title="Attachments"
  existingAttachments={
    notificationDetails?.selectedTemplate?.attachments || []
  }
  newAttachments={newAttachments}
  onAddFiles={handleSelectFile}
  onRemoveNewAttachment={handleRemoveNewAttachment}
  handleRemoveOldAttachment = {handleRemoveOldAttachment}
/>
}
     </Box>
      )}
    </LeadDialog>
  );
};

export default SendNotification;
